<div class="container">
    <h4>{{ 'pleaseCreateEvaluation' | translate}}</h4>
    <div class="sub-container">
        <form (ngSubmit)="this.onEvaluationDataSubmit()"
              [formGroup]="myForm" id="loginForm" name="wf-form-Email-Form" data-name="Email Form" method="get">
            <div>
                <label>{{ 'pleaseChoseName' | translate }}</label>
                <mat-form-field appearance="outline" class="full-width padding-r-0 ">
                    <mat-label>{{ 'evaluationName' | translate }}</mat-label>
                    <input formControlName="name" matInput
                           placeholder="{{ 'pleaseWriteTheNameOfEvaluation' | translate }}">
                </mat-form-field>
                <div class="error"
                     *ngIf="myForm.get('name')?.invalid && (myForm.get('name')?.dirty || myForm.get('name')?.touched)">
                    {{ 'pleaseChoseName' | translate }}
                </div>
            </div>

            <div class="addButtonBlock">
                <label>{{ 'customLabels' | translate}}</label>
                <mat-button-toggle (click)="addCustomTitle()">
                    <mat-icon>add</mat-icon>
                </mat-button-toggle>
            </div>

            <div formArrayName="customTokenTypeTitles">
                <div *ngFor="let customTokenTitle of customTokenTypeTitles.controls; index as index"
                     [formGroupName]="index" class="customTokenTypesBlock">
                    <div class="typeAndTitleBlock">
                        <mat-form-field class="half-width" appearance="outline">
                            <mat-label>Token type</mat-label>
                            <mat-select formControlName="tokenType">
                                <mat-option *ngFor="let item of tokenTypes"
                                            [value]="item.code">{{item.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>


                        <mat-form-field appearance="outline" class="half-width">
                            <mat-label>Benutzerdefinierter Token-Name:</mat-label>
                            <input formControlName="customTitle" matInput>
                        </mat-form-field>
                    </div>

                    <mat-button-toggle
                            (click)="removeCustomTitle(index)">
                        <mat-icon>close</mat-icon>
                    </mat-button-toggle>
                </div>
            </div>


            <!--            <label class="formElement">-->
            <div class="full-width padding-r-0" *ngIf="!this.duplicateId || $any(this.myForm).controls['organization']?.value?.id">
                <label>{{ 'organizationId' | translate}}</label>
                <app-organization-list
                        [formGroup]="myForm"
                        [formControl]="$any(this.myForm).controls['organization']"
                ></app-organization-list>
            </div>
            <!--            </label>-->

            <ng-container *ngIf="myForm.get('organization')?.value">
                <div formArrayName="facilities" class="added-facilities">
                    <div *ngFor="let facility of facilities.controls; index as i" [formGroupName]="i" class="added-facilities">
                        <div class="card-container">

                            <mat-form-field class="one-fifth-width" appearance="outline">
                                <mat-label>{{'facilityName' | translate}}</mat-label>
                                <mat-select formControlName="facility_name" [disabled]="i !== facilities.length - 1">
                                    <mat-option *ngFor="let item of getAvailableFacilities(i)" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                            <mat-form-field appearance="outline" class="one-fifth-width"  *ngIf="shouldShowTokenInput('CUSTOMER')">
                                <mat-label>{{getCustomTokenTitles("CUSTOMER", "TYP_1")}}:</mat-label>
                                <input formControlName="generatedCustomerTokens" matInput type="number"
                                       placeholder="{{getCustomTokenTitles('CUSTOMER', 'TYP_1')}}">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="one-fifth-width" *ngIf="shouldShowTokenInput('EMPLOYEE')">
                                <mat-label>{{getCustomTokenTitles("EMPLOYEE", "TYP_2")}}:</mat-label>
                                <input formControlName="generatedEmployeeTokens" matInput type="number"
                                       placeholder="{{getCustomTokenTitles('EMPLOYEE', 'TYP_2')}}">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="one-fifth-width" *ngIf="shouldShowTokenInput('TEAM')">
                                <mat-label>{{getCustomTokenTitles("TEAM", "TYP_3")}}:</mat-label>
                                <input formControlName="generatedTeamTokens" matInput type="number"
                                       placeholder="{{getCustomTokenTitles('TEAM', 'TYP_3')}}">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="one-fifth-width" *ngIf="shouldShowTokenInput('MANAGEMENT')">
                                <mat-label>{{getCustomTokenTitles("MANAGEMENT", "TYP_4")}}:</mat-label>
                                <input formControlName="generatedManagementTokens" matInput type="number"
                                       placeholder="{{getCustomTokenTitles('MANAGEMENT', 'TYP_4')}}">
                            </mat-form-field>

                            <mat-button-toggle class="facility-icons" *ngIf="i !== facilities.length - 1">
                                <mat-icon (click)="deleteFacility(i)">close</mat-icon>
                            </mat-button-toggle>

                            <mat-button-toggle
                                    *ngIf="i === facilities.length - 1"
                                    type="submit"
                                    [class.disabled]="facilities.invalid"
                                    [disabled]="handleDisableFacilityCreation(i)"
                                    (click)="addTokensForFacility()"
                                    class="facility-icons"
                            >
                                <mat-icon>add</mat-icon>
                            </mat-button-toggle>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="inline-fields gap-10">
                <div class="half-width padding-r-0">
                    <label>{{ 'choseTheDateRange' | translate }}</label>
                    <mat-form-field appearance="outline" class="mat-form-field">
                        <mat-label>Enter a date range</mat-label>
                        <mat-date-range-input [formGroup]="myForm" [rangePicker]="picker">
                            <input matStartDate formControlName="startdate" placeholder="Start date">
                            <input matEndDate formControlName="enddate" placeholder="End date">
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
                <div class="half-width padding-r-0">
                    <label>{{ 'choseColor' | translate }}</label>
                    <mat-form-field class="full-width mat-form-field padding-r-0" appearance="outline">
                        <mat-label>{{ 'choseColor' | translate }}</mat-label>
                        <mat-select formControlName="customization">
                            <mat-option value="assets/styles.css">{{ 'blue' | translate }}</mat-option>
                            <mat-option value="assets/styles-default.css">{{ 'green' | translate }}</mat-option>
                            <mat-option value="assets/styles-test2.css">{{ 'orange' | translate }}</mat-option>
                            <mat-option value="assets/styles-test.css">{{ 'pink' | translate }}</mat-option>
                            <mat-option value="assets/styles-test3.css">{{ 'red' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
<!--            <label>{{ 'description' | translate }}</label>-->
<!--            <mat-form-field appearance="outline" class="full-width padding-r-0">-->
<!--                <mat-label>{{ 'description' | translate }}</mat-label>-->
<!--                <input formControlName="evaluationDescription" matInput>-->
<!--            </mat-form-field>-->

            <div class="upload_file">
                <label class="formElement">
                    <label>{{ 'uploadLogo' | translate}}</label>
                    <input accept=".png, .jpg, .jpeg, .webp" formControlName="logo" type="file" required="false" name="field"
                           data-name="Field"
                           (change)="onLogoLoad($event)">
                </label>

                <div class="preview-container" *ngIf="imagePreview">
                    <img [src]="imagePreview" alt="Preview" class="image-preview">
                </div>
            </div>
            <span class="required">{{ 'required' | translate }}</span>

            <custom-pdf-fields
                    [formGroup]="myForm"
                    [customLogo]="this.imagePreview"
                    [tokenDictionary]="this.updatingEvaluation?.tokenDictionary || null"
                    [facilityName]="this.facilitiesToDisplay?.[0]?.shortname || null"
            />

            <div class="full-width padding-r-0">
                <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header class="extensionPanelHeader">
                            <mat-panel-title class="formElementLabel">
                                FAQ
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-tab-group formGroupName="faq" (selectedTabChange)="onTabChanged($event)">
                            <mat-tab label="DE">
                                <ngx-editor-menu [editor]="editorDe" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editorDe" formControlName="de"></ngx-editor>
                            </mat-tab>
                            <mat-tab label="EN">
                                <ngx-editor-menu [editor]="editorEn" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editorEn" formControlName="en"></ngx-editor>
                            </mat-tab>
                            <mat-tab label="UA">
                                <ngx-editor-menu [editor]="editorUa" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editorUa" formControlName="uk"></ngx-editor>
                            </mat-tab>
                            <mat-tab label="RU">
                                <ngx-editor-menu [editor]="editorRu" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editorRu" formControlName="ru"></ngx-editor>
                            </mat-tab>
                            <mat-tab label="AR">
                                <ngx-editor-menu [editor]="editorAr" [toolbar]="toolbar"></ngx-editor-menu>
                                <ngx-editor [editor]="editorAr" formControlName="ar"></ngx-editor>
                            </mat-tab>
                        </mat-tab-group>
                        <div class="full-width">
                            <button
                                    *ngIf="this.myForm.value?.faq?.[this.selectedTab.value]"
                                    class="showPreviewButton"
                                    mat-button
                                    type="button"
                                    (click)="openFaqPreviewDialog()"
                            >
                                {{'showPreview' | translate}}
                            </button>
                        </div>

                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div class="full-width padding-r-0">
                <button type="submit" [class.disabled]="myForm.invalid" [disabled]="myForm.invalid" class="prim-button">
                    {{ 'goToSurveyCreation' | translate }}
                </button>
            </div>

        </form>
        <app-designer
            *ngIf="this.createdEvaluationID"
            [evaluationId]="this.createdEvaluationID"
            [tokensDictionary]="this.tokensDictionary"
            [evaluationFormData]="myForm.value"
        >
        </app-designer>
    </div>
</div>



